import React, {Fragment} from 'react';
import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

export default function HitPlaceholder() {
    return (
        <Fragment>
            <LoadingPlaceholder
                extraClasses={
                    'thumbnail--noMargin media-flex__figure Hit__loadingThumbnail'
                }
            />
            <div
                className="Hit__infoPlaceholder--mobile"
                data-wdio="HitPlaceholder"
            >
                <LoadingPlaceholder extraClasses="Hit__pricePlaceholder" />
                <LoadingPlaceholder extraClasses="Hit__detailsPlaceholder" />
                <LoadingPlaceholder extraClasses="Hit__reviewsPlaceholder" />
            </div>
            <div
                className="Hit__infoPlaceholder--desktop"
                data-wdio="HitPlaceholder"
            >
                <LoadingPlaceholder extraClasses="Hit__urgencyPlaceholder" />
                <LoadingPlaceholder extraClasses="Hit__headlinePlaceholder" />
                <LoadingPlaceholder extraClasses="Hit__detailsPlaceholder" />
                <LoadingPlaceholder extraClasses="Hit__infoBarPlaceholder" />
            </div>
        </Fragment>
    );
}
